import callApiAxiosClient from '../../axios/axios_client';

export interface PageHelpData {
  title: string;
  content: string;
}

type PageHelpApiResponse =
  | PageHelpData
  | {
      data?: PageHelpData | null;
    }
  | null;

function isPageHelpData(value: unknown): value is PageHelpData {
  return typeof value === 'object' && value !== null && typeof (value as PageHelpData).title === 'string' && typeof (value as PageHelpData).content === 'string';
}

/**
 * Loads contextual help content for a route-derived page key.
 *
 * @param pageKey Route key used to request contextual help content from the backend.
 * @returns The help title/content pair when available, otherwise `null`.
 */
async function getPageHelp(pageKey: string): Promise<PageHelpData | null> {
  if (!pageKey) {
    return null;
  }

  const storedUser = localStorage.getItem('user');

  if (!storedUser) {
    return null;
  }

  let authorization = '';

  try {
    const token = JSON.parse(storedUser);
    authorization = 'Bearer ' + token.token;
  } catch (_error) {
    return null;
  }

  try {
    const response = await callApiAxiosClient<PageHelpApiResponse>({
      method: 'get',
      url: 'programmability/get-page-help',
      headers: {
        'Content-Type': 'Application/json',
        Authorization: authorization,
      },
      params: {
        page_key: pageKey,
      },
    });

    if (isPageHelpData(response)) {
      return response;
    }

    if (typeof response === 'object' && response !== null && isPageHelpData(response.data)) {
      return response.data;
    }

    return null;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      return null;
    }

    throw error;
  }
}

export default getPageHelp;
